export const CONTACT_STATUT = {
  NOUVEAU: 'NOUVEAU',
  DOSSIER_EN_COURS: 'DOSSIER_EN_COURS',
  BAIL_ENVOYE: 'BAIL_ENVOYE',
  BAIL_SIGNE: 'BAIL_SIGNE',
  REFUSE: 'REFUSE',
  ARCHIVE: 'ARCHIVE',
} as const;

export type ContactStatut =
  (typeof CONTACT_STATUT)[keyof typeof CONTACT_STATUT];

export const CIVILITES_CONTACT = ['M.', 'Mme'] as const;

export class ContactTelephone {
  idTelephoneDto?: string;
  numeroDto!: string;
  libelleDto?: string;
  parDefautDto?: boolean;
  dateAjoutDto?: Date | string;
  actifDto?: boolean;
}

export class ContactStatutHistorique {
  idHistoriqueDto?: string;
  statutDto?: ContactStatut;
  statutPrecedentDto?: ContactStatut;
  dateEvenementDto?: Date | string;
  motifDto?: string;
}

/** Aligné sur {@code fr.gavicyconseil.dto.ContactDto}. */
export class Contact {
  idContactDto?: string;
  civiliteDto?: string;
  nomDto!: string;
  prenomDto!: string;
  mailDto?: string;
  notesDto?: string;
  dateEntreeRelationDto?: Date | string;
  statutDto?: ContactStatut;
  actifDto?: boolean;
  motifRefusDto?: string;
  dateRefusDto?: Date | string;
  telephonesDto?: ContactTelephone[];
  historiqueStatutsDto?: ContactStatutHistorique[];
}

/** Clé i18n du libellé de statut (`contacts.statut.*`). */
export function labelStatutContact(statut?: ContactStatut | null): string {
  switch (statut) {
    case CONTACT_STATUT.DOSSIER_EN_COURS:
      return 'contacts.statut.DOSSIER_EN_COURS';
    case CONTACT_STATUT.BAIL_ENVOYE:
      return 'contacts.statut.BAIL_ENVOYE';
    case CONTACT_STATUT.BAIL_SIGNE:
      return 'contacts.statut.BAIL_SIGNE';
    case CONTACT_STATUT.REFUSE:
      return 'contacts.statut.REFUSE';
    case CONTACT_STATUT.ARCHIVE:
      return 'contacts.statut.ARCHIVE';
    case CONTACT_STATUT.NOUVEAU:
    default:
      return 'contacts.statut.NOUVEAU';
  }
}

export function peutRefuserContact(statut?: ContactStatut | null): boolean {
  return (
    statut !== CONTACT_STATUT.REFUSE &&
    statut !== CONTACT_STATUT.ARCHIVE &&
    statut !== CONTACT_STATUT.BAIL_SIGNE
  );
}

export function peutReouvrirContact(statut?: ContactStatut | null): boolean {
  return statut === CONTACT_STATUT.REFUSE;
}

export function telephoneParDefaut(
  contact?: Contact | null
): ContactTelephone | undefined {
  const telephones = contact?.telephonesDto ?? [];
  const actifs = telephones.filter((item) => item.actifDto !== false);
  return (
    actifs.find((item) => item.parDefautDto) ??
    actifs[0] ??
    telephones[0]
  );
}

export function telephonesActifs(contact?: Contact | null): ContactTelephone[] {
  return (contact?.telephonesDto ?? []).filter((item) => item.actifDto !== false);
}
